import React from 'react';
import { Instagram, Facebook, Mail, Phone, Globe } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/noEb8q6RZ64AzhguvHbyeS/WhatsApp_Image_2026-04-15_at_16.02.36_(1).jpg';
export const Footer: React.FC = () => {
  return <footer className="bg-dark-surface border-t border-white/10 pt-16 pb-8 relative z-10" data-id="element-56">
      <div className="max-w-7xl mx-auto px-6" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-58">
          {/* Brand Col */}
          <div className="lg:col-span-2" data-id="element-59">
            <div className="flex items-center gap-3 mb-6" data-id="element-60">
              <img src={LOGO_URL} alt="Impulsador Digital" className="w-12 h-12 rounded-full border border-white/20" data-id="element-61" />
              <span className="font-display font-bold text-2xl tracking-wider" data-id="element-62">
                IMPULSADOR <span className="text-neon-blue" data-id="element-63">DIGITAL</span>
              </span>
            </div>
            <p className="text-silver max-w-md mb-6" data-id="element-64">
              Creamos sitios web de alto impacto visual orientados a generar
              confianza y aumentar las ventas de tu negocio.
            </p>
          </div>

          {/* Contact Col */}
          <div data-id="element-65">
            <h4 className="font-display font-bold text-lg mb-6 text-white" data-id="element-66">
              Contacto
            </h4>
            <ul className="space-y-4 text-silver" data-id="element-67">
              <li data-id="element-68">
                <a href="https://wa.me/5493416660996" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-neon-blue transition-colors" data-id="element-69">
                  <Phone size={18} className="text-neon-blue" data-id="element-70" />
                  +54 9 3416 66-0996
                </a>
              </li>
              <li data-id="element-71">
                <a href="mailto:Soporte.impulsadordigital@gmail.com" className="flex items-center gap-3 hover:text-neon-blue transition-colors break-all" data-id="element-72">
                  <Mail size={18} className="text-neon-blue flex-shrink-0" data-id="element-73" />
                  Soporte.impulsadordigital@gmail.com
                </a>
              </li>
              <li data-id="element-74">
                <a href="http://www.impulsadordigital.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-neon-blue transition-colors" data-id="element-75">
                  <Globe size={18} className="text-neon-blue" data-id="element-76" />
                  impulsadordigital.com
                </a>
              </li>
            </ul>
          </div>

          {/* Social Col */}
          <div data-id="element-77">
            <h4 className="font-display font-bold text-lg mb-6 text-white" data-id="element-78">
              Redes Sociales
            </h4>
            <div className="flex gap-4" data-id="element-79">
              <a href="https://instagram.com/impulsadordigitalpro" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-silver hover:bg-neon-blue hover:text-dark-bg transition-all duration-300" aria-label="Instagram" data-id="element-80">
                <Instagram size={20} data-id="element-81" />
              </a>
              <a href="https://www.facebook.com/share/18m5hF1dAB/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-silver hover:bg-neon-blue hover:text-dark-bg transition-all duration-300" aria-label="Facebook" data-id="element-82">
                <Facebook size={20} data-id="element-83" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-silver/60" data-id="element-84">
          <p data-id="element-85">
            &copy; {new Date().getFullYear()} Impulsador Digital. Todos los
            derechos reservados.
          </p>
          <p data-id="element-86">Diseñado para destacar.</p>
        </div>
      </div>
    </footer>;
};